import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputMask } from "primereact/inputmask";
import { TabPanel, TabView } from "primereact/tabview";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../Base/Components/Card/Card";
import { getAreasAct } from "../../../../Base/API/Global/Areas/AreasRequests";
import { getTypesCategoria } from "../../../../Base/API/Global/Types/TypeRequest";

import {
  EditarActivosFijos,
  GuardarActivosFijos,
  getActivosFijos,
  getSubActivosFijosPorID,
  obtenerCodigoAct,
} from "../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import { getPersonall } from "../../../../API/RRHH/Personal/PersonalRequest";
import { getTasaCambio } from "../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getDetalleProductos } from "../../../../API/Global/ActivosFijos/DetalleProductosRequest";

import SubActivosCRUD from "./SubActivos/SubActivosCRUD";
import DetalleProductosScreen from "./DetalleProductos/DetalleProductosScreen";
import HistoricoTransferenciaScreen from "./HistoricoTransferencia/HistoricoTransferenciaScreen";

const ActivosFijosCRUD = ({
  showDialog,
  selected,
  setSelected,
  setShowDialog,
  getInfo,
  modo,
  ActivoPadre,
  setActivoPadre,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [areas, setAreas] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [types, setTypes] = useState([]);
  const [subTypes, setSubTypes] = useState([]);
  const [activosFijos, setActivosFijos] = useState([]);
  const [activosFijosPadre, setActivosFijosPadre] = useState([]);
  const [subActivosList, setSubActivosList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [showDialog2, setShowDialog2] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [titleHeader, setTitleHeader] = useState("");
  const [detProductosList, setDetProductosList] = useState([]);
  const [showVisible, setShowVisible] = useState(false);

  const initialValues = {
    IdActivo: -1,
    IdEstado: selected ? selected?.IdStatus : 110,
    AbbreviatedType: "",
  };

  const {
    values,
    handleInputChange,
    setValues,
    resetForm,
    error,
    setError,
    setNumber,
  } = useForm(initialValues);

  const getValoresIniciales = async (infoNueva) => {
    setLoading(true);
    let selected2 = infoNueva ? infoNueva : selected
    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const b = await getActivosFijos();
    setActivosFijos(b);
    const filterPadre = b.filter((item) => item.ActivoPadre === true);

    const dataMapeada = filterPadre.map((e) => ({
      IdActivoPadre: e?.IdActivo,
      NombreActivoPadre: e?.NombreActivo,
      ComentarioPadre: e?.Comentario,
      MarcaPadre: e?.Marca,
      ModeloPadre: e?.Modelo,
      AnoPadre: e?.Ano,
      IdAreaPadre: e?.IdArea,
      NombreAreaPadre: e?.Area,
      IdTypePadre: e?.IdTipoActivo,
      TypePadre: e?.Type,
    }));

    setActivosFijosPadre(dataMapeada);

    const persoTempo = await getPersonall();
    setPersonal(persoTempo);

    const typesTempo = await getTypesCategoria("ActivoFijo");
    setTypes(typesTempo);

    const subTypesTempo = await getTypesCategoria("SubTipoActivo");
    setSubTypes(subTypesTempo);

    if (selected?.IdActivo) {
      const subActivosTempo = await getSubActivosFijosPorID(selected?.IdActivo);
      setSubActivosList(subActivosTempo);

      const detalleP = await getDetalleProductos();
      const filterDetalle = detalleP.filter(
        (item) => item.IdActivo === selected?.IdActivo
      );
      setDetProductosList(filterDetalle);
      setLoading(false);
    }

    const tasaTmepo = await getTasaCambio();

    setValues({
      ...selected2,
      Area: areasTempo.find((t) => selected2?.IdArea === t.IdArea),
      Personal: persoTempo.find((t) => selected2?.IdPersonal === t.IdPersonal),
      Type: typesTempo.find((t) => selected2?.IdTipoActivo === t.IdType),
      SubType: subTypesTempo.find(
        (st) => selected2?.IdSubTipoActivo === st.IdType
      ),
      TasaCambio: selected2?.TasaCambio
        ? selected2?.TasaCambio
        : tasaTmepo[0]?.TasaCambio,
      FechaAdquisicion: selected2?.FechaAdquisicion
        ? new Date(selected2?.FechaAdquisicion)
        : new Date(),
      FechaUso: selected2?.FechaUso ? new Date(selected2?.FechaUso) : new Date(),
    });

    setLoading(false);
  };

  const cambiarCodigo = async (IdTipoActivo) => {
    const nuevoCodigo = await obtenerCodigoAct(
      IdTipoActivo,
      values?.CodigoActivo
    );
    setValues({
      ...values,
      CodigoActivo: nuevoCodigo,
    });
  };

  const getInfoSub = async () => {
    const subActivosTempo = await getSubActivosFijosPorID(selected?.IdActivo);
    setSubActivosList(subActivosTempo);
    setLoading(false);
  };

  const generateCodigoActivo = (tipoAbbr) => {
    const activosDelMismoTipo = activosFijos.filter(
      (activo) => activo.AbbreviatedType === tipoAbbr
    );
    const ultimoNumero = activosDelMismoTipo.reduce((max, activo) => {
      const numero = parseInt(activo.CodigoActivo.split("-")[1], 10);
      return numero > max ? numero : max;
    }, 0);

    const nuevoNumero = (ultimoNumero + 1).toString().padStart(4, "0");
    return `${tipoAbbr}-${nuevoNumero}`;
  };

  const handleInputChangeWithCodigo = (e) => {
    handleInputChange(e);
    if (e.target.name === "Type") {
      const selectedType = types.find(
        (type) => type?.IdType === e.target.value?.IdType
      );
      if (selectedType && modo === "Crear") {
        const nuevoCodigoActivo = generateCodigoActivo(
          selectedType.AbbreviatedType
        );
        setValues((prevValues) => ({
          ...prevValues,
          AbbreviatedType: selectedType.AbbreviatedType,
          CodigoActivo: nuevoCodigoActivo,
        }));
      }
    }
  };

  useEffect(() => {
    if (values.Type && values.Type.IdType && modo === "Crear") {
      const selectedType = types.find(
        (type) => type.IdType === values.Type.IdType
      );
      if (selectedType) {
        const nuevoCodigoActivo = generateCodigoActivo(
          selectedType.AbbreviatedType
        );
        setValues((prevValues) => ({
          ...prevValues,
          AbbreviatedType: selectedType.AbbreviatedType,
          CodigoActivo: nuevoCodigoActivo,
        }));
      }
    }
  }, [values.Type, modo]);

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setActivoPadre(false);
    getInfo();
    setSelected([]);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreActivo) {
      error.NombreActivo = true;
      error.error = true;
    }

    if (!values.Type || !values.Type.IdType) {
      error.IdType = true;
      error.error = true;
    }
    if (!values.Area || !values.Area.IdArea) {
      error.IdArea = true;
      error.error = true;
    }

    if (!ActivoPadre) {
      if (values?.TieneActivoPadre === true) {
        let IdActivoPadre =
          values?.NombreActivoPadre?.IdActivoPadre || values?.IdActivoPadre;
        if (!IdActivoPadre) {
          error.IdActivoPadre = true;
          error.error = true;
        }
      }
      if (!values.Valor) {
        error.Valor = true;
        error.error = true;
      }
      if (!values.VidaUtil) {
        error.VidaUtil = true;
        error.error = true;
      }
    }
    setError(error);
    return error;
  };

  const agregarActivoFijo = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const Datos = {
        IdActivo: values?.IdActivo,
        NombreActivo: values?.NombreActivo,
        CodigoActivo: values?.CodigoActivo,
        Marca: values?.Marca,
        Modelo: values?.Modelo,
        Serie: values?.Serie,
        Ano: values?.Ano,
        IdArea: values.Area?.IdArea,
        // IdStatus: values?.Estado.IdStatus,
        IdPersonal: values.Personal?.IdPersonal,
        IdTipoActivo: values.Type?.IdType,
        Comentario: values?.Comentario,
        FechaCreado: new Date(),
        FechaAdquisicion: new Date(values?.FechaAdquisicion),
        FechaUso: new Date(values?.FechaUso),
        Valor: values?.Valor,
        VidaUtil: values?.VidaUtil,
        TasaCambio: values?.TasaCambio,
        ActivoPadre: ActivoPadre ? ActivoPadre : false,
        IdActivoPadre:
          values?.NombreActivoPadre?.IdActivoPadre || values?.IdActivoPadre,
        TieneActivoPadre: values?.TieneActivoPadre,
        IdUserEdit: userAuth?.IdUser,
        IdSubTipoActivo: values.SubType?.IdType,
      };

      if (Datos.IdActivo > 0) {
        setLoading(true);
        const resultado = await EditarActivosFijos(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await GuardarActivosFijos(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
        }
        setLoading(false);
      }
    }
  };

  //Tabla Sub-Activos
  const columnsSA = [
    {
      field: "IdSubActivo",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdSubActivo,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "CodigoSubActivo",
      header: "Código SubActivo",
      headerEn: "SubActive Code",
      frozen: true,
      Sumary: "count",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog2(true);
        setSelectedSub(data);
      },
    },
    {
      header: "Nombre SubActivo",
      headerEn: "AsSubActivo Name",
      field: "NombreSubActivo",
      className: "large",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog2(true);
        setSelectedSub(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      frozen: true,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      header: "Fecha Adquisición",
      headerEn: "Acquisition Date",
      field: "FechaAdquisicion",
      className: "small",
    },
    {
      header: "Fecha Uso",
      headerEn: "Use Date",
      field: "FechaUso",
      className: "small",
    },
    {
      header: "Vida Util",
      headerEn: "Useful life",
      field: "VidaUtil",
      className: "small",
      Format: "Currency",
    },
    {
      header: "Valor Lempiras",
      headerEn: "Lempiras Value",
      field: "ValorL",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      header: "Valor Dolares",
      headerEn: "Dollar Value",
      field: "ValorD",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      header: "Código Activo",
      headerEn: "Active Code",
      field: "CodigoActivo",
      className: "small",
    },
    {
      header: "Nombre Activo",
      headerEn: "Active Name",
      field: "NombreActivo",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      className: "large",
    },
    {
      field: "IdSubActivo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog2(true);
            setSelectedSub(rowData);
          },
        },
      ],
    },
  ];

  const tableSA = {
    Columns: columnsSA,
    Data: subActivosList,
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      {activeIndex === 0 && (
        <Button
          label={selected?.IdActivo ? "Modificar" : "Guardar"}
          icon="pi pi-check"
          className="p-button-text"
          onClick={agregarActivoFijo}
          loading={loading}
        />
      )}
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  useEffect(() => {
    const IdActivoPadre =
      values?.NombreActivoPadre?.IdActivoPadre || values?.IdActivoPadre;
    if (IdActivoPadre) {
      setValues({
        ...values,
        NombreActivo: values?.NombreActivoPadre?.NombreActivoPadre,
        Comentario: values?.NombreActivoPadre?.ComentarioPadre,
        Ano: values?.NombreActivoPadre?.AnoPadre,
        Marca: values?.NombreActivoPadre?.MarcaPadre,
        Modelo: values?.NombreActivoPadre?.ModeloPadre,
        IdArea: values?.NombreActivoPadre?.IdAreaPadre,
        // Area: {
        //   IdArea: values?.NombreActivoPadre?.IdAreaPadre,
        //   Area:values?.NombreActivoPadre?.NombreAreaPadre
        // },
        IdTipoActivo: values?.NombreActivoPadre?.IdTypePadre,
        Type: {
          IdType: values?.NombreActivoPadre?.IdTypePadre,
          Type: values?.NombreActivoPadre?.TypePadre,
        },
      });
    } else {
      setValues({
        ...values,
        NombreActivo: "",
        Comentario: "",
        Ano: "",
        Marca: "",
        // IdArea: null,
        // Area: null,
        IdTipoActivo: null,
        Type: null,
        IdActivoPadre: null,
      });
    }
  }, [values?.NombreActivoPadre?.IdActivoPadre]);

  useEffect(() => {
    if (values?.TieneActivoPadre === false) {
      setValues((prevValues) => ({
        ...prevValues,
        NombreActivo: "",
        Comentario: "",
        Ano: "",
        Marca: "",
        // IdArea: null,
        // Area: null,
        IdTipoActivo: null,
        Type: null,
        IdActivoPadre: null,
      }));
    }
  }, [values?.TieneActivoPadre]);

  useEffect(() => {
    switch (activeIndex) {
      case 1:
        setTitleHeader("Sub Activos Fijos");
        break;
      case 2:
        setTitleHeader("Suministros");
        break;
      case 3:
        setTitleHeader("Repuestos");
        break;
      default:
        setTitleHeader("Activos Fijos");
    }
  }, [activeIndex]);

  useEffect(() => {
    let IdTipoActivo = values?.Type?.IdType
      ? values?.Type?.IdType
      : values?.IdTipoActivo;
    if (!ActivoPadre) {
      if (
        values?.IdActivo > 0 &&
        values?.Type?.IdType &&
        values?.IdTipoActivo
      ) {
        if (values?.Type?.IdType !== values?.IdTipoActivo) {
          toastShow(
            toast,
            "warn",
            "Adverencia",
            "Al momento de guardar se cambiara el Tipo de Activo, por lo tanto cambiara el código."
          );
          cambiarCodigo(IdTipoActivo);
        } else {
          setValues({
            ...values,
            CodigoActivo: selected?.CodigoActivo,
          });
        }
      }
    }
  }, [values?.Type?.IdType]);

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        footer={DialogFooter}
        onHide={onHide}
        header={
          <div style={{ display: "flex", alignItems: "center" }}>
            <h4>{titleHeader}</h4>
            <h4 className="mx-2">{values?.CodigoActivo || ""}</h4>
            {activeIndex === 1 && (
              <Button
                icon="pi pi-plus"
                text
                tooltip="Agregar SubActivo"
                aria-label="Filter"
                lassName="p-button-success mx-1"
                onClick={() => setShowDialog2(true)}
              />
            )}
          </div>
        }
        style={{ width: "65%", height: !ActivoPadre ? "81%" : "73%" }}
      >
        <Toast ref={toast} />

        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header={"Datos Generales"}>
            <div id="Dialog">
              <Loader loading={loading} querySelector={"#Dialog"} />
              <div style={{ width: "100%", margin: "auto" }}>
                {/* Tiene Padre */}
                {!ActivoPadre && (
                  <div
                    className="modal__input-contenedor"
                    style={{ height: "4vh" }}
                  >
                    <div className="field col-4 me-2">
                      <span className="p-float-label">
                        <Checkbox
                          checked={values.TieneActivoPadre}
                          onChange={(e) =>
                            setValues({
                              ...values,
                              TieneActivoPadre: e.target.checked,
                            })
                          }
                        />
                        <label htmlFor="AutorizaGerente">
                          &nbsp;&nbsp;&nbsp;Tiene Activo Padre
                        </label>
                      </span>
                    </div>

                    {values?.TieneActivoPadre && (
                      <div className="field col-4">
                        <span className="p-float-label">
                          <AutoCompleteDropdown
                            name={"NombreActivoPadre"}
                            value={values?.NombreActivoPadre}
                            items={activosFijosPadre}
                            field={"NombreActivoPadre"}
                            label={"Activo Padre"}
                            handleInputChange={handleInputChange}
                            className={error.IdActivoPadre ? "p-invalid" : ""}
                          />
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div className="modal__input-contenedor">
                  {/* Nombre */}
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="NombreActivo"
                        value={values.NombreActivo}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.NombreActivo ? "p-invalid" : ""}
                      />
                      <label htmlFor="NombreActivo">Nombre Activo</label>
                    </span>
                  </div>
                  {/* Comentario */}
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Comentario"
                        value={values.Comentario}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.Comentario ? "p-invalid" : ""}
                      />
                      <label htmlFor="Comentario">Comentario</label>
                    </span>
                  </div>
                  {/* Tipo Activo */}
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Type"}
                        value={values.Type}
                        items={types}
                        field={"Type"}
                        label={"Tipo Activo"}
                        handleInputChange={handleInputChangeWithCodigo}
                        enable={!values.TieneActivoPadre}
                        className={error.IdType ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  {/* Tipo Activo */}
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"SubType"}
                        value={values.SubType}
                        items={subTypes}
                        field={"Type"}
                        label={"Sub Tipo Activo"}
                        handleInputChange={handleInputChangeWithCodigo}
                      />
                    </span>
                  </div>

                  {/* Area */}
                  {/* {!ActivoPadre &&(
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Area"}
                          value={values.Area}
                          items={areas}
                          field={"Area"}
                          label={"Area"}
                          handleInputChange={handleInputChange}
                          className={error.IdArea ? "p-invalid" : ""}
                        />
                      </span>
                    </div>
                  )} */}

                  {/* Marca */}
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Marca"
                        value={values.Marca}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        disabled={values.TieneActivoPadre}
                        className={error.Marca ? "p-invalid" : ""}
                      />
                      <label htmlFor="Marca">Marca</label>
                    </span>
                  </div>

                  {/* Modelo */}
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Modelo"
                        value={values.Modelo}
                        onChange={handleInputChange}
                        disabled={values.TieneActivoPadre}
                        style={{ width: "100%" }}
                        className={error.Modelo ? "p-invalid" : ""}
                      />
                      <label htmlFor="Modelo">Modelo</label>
                    </span>
                  </div>
                </div>

                {ActivoPadre && (
                  <div className="modal__input-contenedor">
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputMask
                          name="Ano"
                          mask="9999"
                          value={values.Ano}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          className={error.Ano ? "p-invalid" : ""}
                          disabled={values.TieneActivoPadre}
                        />
                        <label htmlFor="Ano">Año</label>
                      </span>
                    </div>
                  </div>
                )}

                {!ActivoPadre && (
                  <div className="modal__input-contenedor">
                    {/* Serie */}
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputText
                          name="Serie"
                          value={values.Serie}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          className={error.Serie ? "p-invalid" : ""}
                        />
                        <label htmlFor="Serie">Serie</label>
                      </span>
                    </div>

                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputMask
                          name="Ano"
                          mask="9999"
                          value={values.Ano}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          className={error.Ano ? "p-invalid" : ""}
                          disabled={values.TieneActivoPadre}
                        />
                        <label htmlFor="Ano">Año</label>
                      </span>
                    </div>

                    {/* Fecha Adq */}
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label p-input-icon-right col-12">
                        <Calendar
                          selectionMode="single"
                          value={values?.FechaAdquisicion}
                          onChange={handleInputChange}
                          name="FechaAdquisicion"
                          style={{ width: "100%" }}
                          dateFormat={"dd/mm/yy"}
                          showIcon
                        />
                        <label htmlFor="righticon">Fecha Adquisición</label>
                      </span>
                    </div>
                  </div>
                )}

                {!ActivoPadre && (
                  <div className="modal__input-contenedor">
                    {/* Fecha Uso */}
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label p-input-icon-right col-12">
                        {/* <i className="pi pi-spin pi-spinner" /> */}
                        <Calendar
                          dateFormat={"dd/mm/yy"}
                          selectionMode="single"
                          value={values?.FechaUso}
                          onChange={handleInputChange}
                          name="FechaUso"
                          style={{ width: "100%" }}
                          minDate={values?.FechaAdquisicion}
                          showIcon
                        />
                        <label htmlFor="righticon">Fecha uso</label>
                      </span>
                    </div>

                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Area"}
                          value={values.Area}
                          items={areas}
                          field={"Area"}
                          label={"Area"}
                          handleInputChange={handleInputChange}
                          className={error.IdArea ? "p-invalid" : ""}
                        />
                      </span>
                    </div>

                    {/* Personal */}
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Personal"}
                          value={values.Personal}
                          items={personal}
                          field={"NombreCompleto"}
                          label={"Personal"}
                          handleInputChange={handleInputChangeWithCodigo}
                          className={error.IdPersonal ? "p-invalid" : ""}
                        />
                      </span>
                    </div>
                  </div>
                )}

                {!ActivoPadre && (
                  <div className="mt-2 d-flex justify-content-end">
                    <div style={{ marginRight: 45 }}>
                      <Button
                        icon="pi pi-plus"
                        tooltip="Cambiar Asignación"
                        aria-label="Filter"
                        onClick={() => setShowVisible(true)}
                      />
                    </div>
                  </div>
                )}

                <div className="modal__input-contenedor hidden">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="CodigoActivo"
                        value={values.CodigoActivo}
                        onChange={handleInputChangeWithCodigo}
                        style={{ width: "100%" }}
                        className={error.CodigoActivo ? "p-invalid" : ""}
                      />
                      <label htmlFor="CodigoActivo">Código Activo</label>
                    </span>
                  </div>
                </div>

                {/* Valores */}
                {!ActivoPadre && (
                  <div className="mt-4 mx-4">
                    <Card
                      titulo={<h4>Valores</h4>}
                      contenido={
                        <div
                          className="modal__input-contenedor"
                          style={{ height: "8vh" }}
                        >
                          <div className="field col-3 me-2">
                            <span className="p-float-label">
                              <InputNumber
                                id="righticon"
                                value={values?.Valor}
                                onChange={(e) => setNumber(e, "Valor")}
                                name={"Valor"}
                                style={{ width: "100%" }}
                                mode="decimal"
                                prefix="L "
                                minFractionDigits={2}
                                maxFractionDigits={4}
                                className={error.Valor ? "p-invalid" : ""}
                              />
                              <label htmlFor="Valor">Valor activo</label>
                            </span>
                          </div>

                          <div className="field col-3 me-2">
                            <span className="p-float-label">
                              <InputNumber
                                id="VidaUtil"
                                value={values?.VidaUtil}
                                onChange={(e) => setNumber(e, "VidaUtil")}
                                name={"VidaUtil"}
                                mode="decimal"
                                suffix=" años"
                                style={{ width: "100%" }}
                                className={error.VidaUtil ? "p-invalid" : ""}
                              />
                              <label htmlFor="righticon">Vida util</label>
                            </span>
                          </div>
                          <div className="field col-3 me-2">
                            <span className="p-float-label">
                              <InputNumber
                                value={
                                  values?.VidaUtil
                                    ? (1 / values.VidaUtil) * 100
                                    : 0
                                }
                                suffix=" %"
                                disabled
                                style={{ width: "100%" }}
                              />
                              <label htmlFor="righticon">
                                Porcentaje de depreciación
                              </label>
                            </span>
                          </div>
                          <div className="field col-3 me-2">
                            <span className="p-float-label">
                              <InputText
                                id="righticon"
                                value={values?.TasaCambio}
                                onChange={handleInputChange}
                                name={"TasaCambio"}
                                style={{ width: "100%" }}
                                className={error.TasaCambio ? "p-invalid" : ""}
                                // disabled
                              />
                              <label htmlFor="righticon">Tasa de Cambio</label>
                            </span>
                          </div>
                        </div>
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </TabPanel>

          {selected && !ActivoPadre && values?.IdActivo > 0 ? (
            <TabPanel header={"SubActivos"}>
              <div style={{ height: "52vh" }}>
                <AgGrid table={tableSA} />
              </div>
            </TabPanel>
          ) : (
            ""
          )}

          {selected?.IdActivo > 0 &&
            ["Suministros", "Repuestos"].map((titulo, index) => (
              <TabPanel header={titulo} key={titulo}>
                <DetalleProductosScreen
                  activeIndex={index + 2}
                  selected={selected}
                  setDetProductosList={setDetProductosList}
                />
              </TabPanel>
            ))}

          {selected?.IdActivo > 0 && (
            <TabPanel header={"Historico Transferencias"}>
              <div style={{ height: "52vh" }}>
                <HistoricoTransferenciaScreen IdActivo={selected?.IdActivo}/>
              </div>
            </TabPanel>
          )}
        </TabView>
      </Dialog>

      {showDialog2 && (
        <SubActivosCRUD
          toastRef={toast}
          showDialog={showDialog2}
          selected={selectedSub}
          setSelected={setSelectedSub}
          setShowDialog={setShowDialog2}
          getInfo={getInfoSub}
          modo={selectedSub ? "Editar" : "Crear"}
          IdActivo={selected?.IdActivo}
        />
      )}

      <Dialog
        header={"Historico Tranferencias"}
        visible={showVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!showVisible) return;
          setShowVisible(false);
        }}
      >
        <HistoricoTransferenciaScreen
          selectedActivo={selected}
          setShowVisible={setShowVisible}
          getInfoGeneral={getValoresIniciales}
        />
      </Dialog>
    </div>
  );
};

export default ActivosFijosCRUD;
